import React, { useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';
import { routes } from '../../routes';
import {
  MultipleSelectableSmallProductCardList,
  SmallProductCardList,
  ColumnFlexBox,
  EmptyStateWrapper,
  Container,
  If,
} from '../../Components';
import { multiSelect } from '../../utils/multiSelect';
import { getCurrentOrder } from '../../selectors';
import { isOrderEditable } from '../../utils/order';
import { AddMultipleItems } from './AddMultipleItems';
import { translate } from './translate';
import { MultiSelectItemsForOrder } from './MultiSelectItemsForOrder';

export const Products = withRouter(
  ({ products, history, colours, tischOffensiveId }) => {
    const context = useContext(AppContext);
    const marketing = !!context.state.marketing;
    const currentOrder = getCurrentOrder(context);

    const { setMultiSelectItems, multiSelectItems } = MultiSelectItemsForOrder(
      currentOrder,
    );

    const noData = _.size(products);
    const orderIsEditable = isOrderEditable(_.get(currentOrder, 'doc')) && !marketing;

    return (
      <>
        <ColumnFlexBox>
          <EmptyStateWrapper
            title={translate('emptyState.title')}
            description={translate('emptyState.description')}
            condition={noData}>
            {() => (
              <Container>
                <If condition={orderIsEditable}>
                  {() => (
                    <MultipleSelectableSmallProductCardList
                      onSelect={(itemToInsertOrRemove) => setMultiSelectItems(
                        multiSelect({
                          itemToInsertOrRemove,
                          multiSelectItems,
                        }),
                      )}
                      selectedProducts={multiSelectItems}
                      products={products}
                      tischOffensiveId={tischOffensiveId}
                      colours={colours}
                      onClick={(name, color, tischOffensiveId) => history.push(routes.productDetail({ name, color, tischOffensiveId }))}
                    />
                  )}
                </If>
                <If condition={!orderIsEditable}>
                  {() => (
                    <SmallProductCardList
                      products={products}
                      tischOffensiveId={tischOffensiveId}
                      colours={colours}
                      onClick={(name, color, tischOffensiveId) => history.push(routes.productDetail({ name, color, tischOffensiveId }))}
                    />
                  )}
                </If>
                <If condition={orderIsEditable}>
                  {() => (
                    <AddMultipleItems
                      products={products}
                      tischOffensiveId={tischOffensiveId}
                      colours={colours}
                      isAddAllProductsEnabled={
                        !!tischOffensiveId && !!orderIsEditable
                      }
                      onAdd={() => setMultiSelectItems([])}
                      multiSelectItems={multiSelectItems}
                    />
                  )}
                </If>
              </Container>
            )}
          </EmptyStateWrapper>
        </ColumnFlexBox>
      </>
    );
  },
);
